export default __webpack_public_path__ + "static/medium-image-norsk-2-ed0d865f9f335269eeadaa81b5714c3d.png";